import React from 'react';
import { Reveal } from '../Reveal';
import type { CaseStudy } from '../../types/content';
interface DesignDirectionBlockProps {
  study: CaseStudy;
}
export function DesignDirectionBlock({
  study
}: DesignDirectionBlockProps) {
  return <div className="grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-184" data-mp="1nm9h4rnhewuh">
      <Reveal data-id="element-185" data-mp="1slcmyebad73i">
        <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-186" data-mp="1sjruqvcg208t">Typography</p>
        <ul className="mt-5 border-t border-hairline" data-id="element-187" data-mp="vvd4ns5c2u7q">
          {study.typefaces.map(typeface => <li key={typeface.name} className="border-b border-hairline py-4" data-id="element-188" data-mp="zvdra02l6bpv">
              <p className="font-serif text-[26px] leading-none tracking-[-0.03em] text-ink" data-id="element-189" data-mp="14uqfop93vquk">
                {typeface.name}
              </p>
              <p className="mt-2 text-small leading-5 text-muted" data-id="element-190" data-mp="19njih7l0kp40">{typeface.role}</p>
            </li>)}
        </ul>
      </Reveal>

      <Reveal delay={0.06} data-id="element-191" data-mp="h5nzzmy1882p">
        <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-192" data-mp="h4w388sp84au">Colour</p>
        <ul className="mt-5 border-t border-hairline" data-id="element-193" data-mp="27gedb0rh50zg">
          {study.palette.map(swatch => <li key={swatch.hex} className="flex items-center gap-4 border-b border-hairline py-3" data-id="element-194" data-mp="23dricqziazy1">
              <span aria-hidden="true" className="h-8 w-12 shrink-0 rounded-sm border border-hairline" style={{
            backgroundColor: swatch.hex
          }} data-id="element-195" data-mp="1yn1an73lyl06" />
              <span className="text-small text-ink" data-id="element-196" data-mp="1opn88beirwqv">{swatch.name}</span>
              <span className="ml-auto text-small tabular-nums text-muted" data-id="element-197" data-mp="1jqab8xtxp9ak">{swatch.hex}</span>
            </li>)}
        </ul>
      </Reveal>

      <Reveal delay={0.12} data-id="element-198" data-mp="1fpi182d8n0d8">
        <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-199" data-mp="1fqt665if6e5x">Components</p>
        <ul className="mt-5 border-t border-hairline" data-id="element-200" data-mp="1argg7bw94qz4">
          {study.components.map(component => <li key={component} className="border-b border-hairline py-3 text-small leading-6 text-ink" data-id="element-201" data-mp="3a0nb3oex4910">
              {component}
            </li>)}
        </ul>
      </Reveal>
    </div>;
}